// extracted by mini-css-extract-plugin
export default {"modal":"kN-z","modalOverlay":"lN-z","outfitHeading":"mN-z"};